<template>
  <div class="mb-4">
    <h5 class="mb-2">
      {{ "query_was_done" | setText("Заявка успешно выполнена") }}
    </h5>
  </div>
</template>
<script>
export default {
  methods: {},
  data: () => ({}),
  props: ["value", "data"],
};
</script>
<style>
</style>
 